import React from 'react';
import { motion } from 'framer-motion';
import { Home, Compass, MessageSquare, User } from 'lucide-react';
const navItems = [{
  icon: Home,
  label: 'Home',
  active: true
}, {
  icon: Compass,
  label: 'Discover',
  active: false
}, {
  icon: MessageSquare,
  label: 'Concierge',
  active: false
}, {
  icon: User,
  label: 'Profile',
  active: false
}];
export function BottomNav() {
  return <div className="fixed bottom-0 inset-x-0 z-50 flex justify-center pb-6 pt-4 px-6 pointer-events-none" data-id="element-23">
      <motion.nav initial={{
      y: 50,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} transition={{
      delay: 0.8,
      duration: 0.8,
      ease: [0.16, 1, 0.3, 1]
    }} className="glass-nav rounded-full px-6 py-3 flex items-center justify-between w-full max-w-md pointer-events-auto shadow-2xl" data-id="element-24">
        {navItems.map((item, idx) => {
        const Icon = item.icon;
        return <motion.button key={idx} whileTap={{
          scale: 0.85,
          transition: {
            type: 'spring',
            stiffness: 400,
            damping: 17
          }
        }} className="flex flex-col items-center gap-1 p-2 relative group" data-id="element-25">
              <Icon className={`w-5 h-5 transition-colors duration-300 ${item.active ? 'text-desert-dusk' : 'text-titanium-400 group-hover:text-titanium-200'}`} strokeWidth={item.active ? 2 : 1.5} data-id="element-26" />
              {item.active && <motion.div layoutId="activeNav" className="absolute -bottom-1 w-1 h-1 rounded-full bg-desert-dusk" data-id="element-27" />}
            </motion.button>;
      })}
      </motion.nav>
    </div>;
}